var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Sound } from "./base";
import { safePlayAudio } from "./utils";
/**
 * 空音频
 */
var NOTHING = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
/**
 * 音效
 */
var SoundEffect = /** @class */ (function (_super) {
    __extends(SoundEffect, _super);
    function SoundEffect(opts) {
        var _a, _b;
        var _this = _super.call(this) || this;
        /**
         * 音频元素池
         */
        _this._pool = [];
        _this._allBulletReady = false;
        _this._defaultVolume = (_a = opts.volume) !== null && _a !== void 0 ? _a : 0.5;
        _this._effectsDict = (_b = opts.effectsDict) !== null && _b !== void 0 ? _b : {};
        var _c = opts.poolSize, poolSize = _c === void 0 ? 10 : _c;
        for (var i = 0; i < poolSize; i++) {
            var audio = document.createElement("audio");
            audio.setAttribute("src", NOTHING);
            audio.load();
            _this._pool.push(document.createElement("audio"));
        }
        return _this;
    }
    // 让池子里的所有的 audio 都处于可用状态
    SoundEffect.prototype._loadAllBullet = function () {
        var e_1, _a;
        if (!this._allBulletReady) {
            try {
                for (var _b = __values(this._pool), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var bullet = _c.value;
                    safePlayAudio(bullet, function (err) { return console.warn(err); });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this._allBulletReady = true;
        }
    };
    SoundEffect.prototype.enable = function () {
        this.isEnable = true;
    };
    SoundEffect.prototype.disable = function () {
        this.isEnable = false;
    };
    /**
     * 播放音效
     */
    SoundEffect.prototype.play = function (
    /**
     * 音效 Key | 音效地址
     */
    keyOrSrc, opts) {
        var _this = this;
        if (this.isEnable === false) {
            return;
        }
        var audio = this._pool.pop();
        if (!audio) {
            return;
        }
        var _a = (opts || {}).volume, volume = _a === void 0 ? this._defaultVolume : _a;
        audio.volume = volume;
        var src = this._effectsDict[keyOrSrc] || keyOrSrc;
        audio.setAttribute("src", src);
        audio.load();
        audio.onended = function () {
            audio.setAttribute("src", NOTHING);
            audio.load();
            _this._pool.push(audio);
        };
        safePlayAudio(audio, function (err) {
            console.warn(err);
            _this._pool.push(audio);
        });
        this._loadAllBullet();
    };
    return SoundEffect;
}(Sound));
export { SoundEffect };
